import ApiCache, { apiCaches } from "./apiCache"
import api from "./api"
import { DataDefinitionWithFields, DataSource, DataSourceItem } from "@/types"
import { CurrentUser } from "@/types/user"

/**
 * Caches frequently used API requests for the default api service.
 */
class ApiDefaultCache extends ApiCache {
	protected cacheName = "ApiDefaultCache"

	// #region Standard API Methods

	public async dataSourceGet (dataSourceId: string): ReturnType<typeof api.dataSourceGet> {
		const methodName = "dataSourceGet"
		const fetchCallFn = () => api.dataSourceGet(dataSourceId)

		const dataPromise = this.getOrFetchAndStore(methodName, { dataSourceId }, fetchCallFn)
		return dataPromise as Promise<DataSource>
	}

	public async definitionDetails (definitionId: string): ReturnType<typeof api.definitionDetails> {
		const methodName = "definitionDetails"
		const fetchCallFn = () => api.definitionDetails(definitionId)

		const dataPromise = this.getOrFetchAndStore(methodName, { definitionId }, fetchCallFn)
		return dataPromise as Promise<DataDefinitionWithFields>
	}

	public async dataSourceGetAll (dataSourceId: string, getAll: boolean): ReturnType<typeof api.dataSourceGetAll> {
		const methodName = "dataSourceGetAll"
		const fetchCallFn = () => api.dataSourceGetAll(dataSourceId, getAll)

		const dataPromise = this.getOrFetchAndStore(methodName, { dataSourceId, getAll }, fetchCallFn)
		return dataPromise as Promise<DataSourceItem[]>
	}

	public async userDetails (userId: string): ReturnType<typeof api.userDetails> {
		const methodName = "userDetails"
		const fetchCallFn = () => api.userDetails(userId)

		const dataPromise = this.getOrFetchAndStore(methodName, { userId }, fetchCallFn)
		return dataPromise as Promise<CurrentUser>
	}

	// #endregion

	// #region Specialized Methods

	public async columnValuesForField (fieldId: string, columnValuesFn: (apiInstance: typeof api) => Promise<unknown>): Promise<unknown> {
		const methodName = "columnValuesForField"
		const fetchCallFn = () => columnValuesFn(api)

		const dataPromise = this.getOrFetchAndStore(methodName, { fieldId }, fetchCallFn)
		return dataPromise as Promise<unknown>
	}

	// #endregion
}

const apiDefaultCache = new ApiDefaultCache()
export default apiDefaultCache

// Register the cache in the global API Cache list.
apiCaches.push(apiDefaultCache)
